import React, { useContext, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import LimeController from '../../controllers/LimeController'
import Dialog from '../../components/Dialog'
import AppContext from '../../appContext'
import { bind } from '../../wrapper'
import Success from '../../components/Success'
import UpsertLimingTemplate from './UpsertLimingTemplate'

const LimingTemplateApproval: React.FC = () => {
    const context = useContext(AppContext)
    const params = useParams()
    const [showDecline, setShowDecline] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const navigate = useNavigate()
    const templateId = parseInt(params.id as string)

    function approve() {
        setShowConfirm(false)
        LimeController.approveTemplate({ id: templateId }).then(() => {
            context.showSnack(<Success title={context.word('successfully_approved')} />)
            navigate('/liming/approvals')
        })
    }

    function decline(message: string) {
        setShowDecline(false)
        LimeController.declineTemplate({ id: templateId, message }).then(() => {
            context.showSnack(context.word('declined'))
            navigate('/liming/approvals')
        })
    }

    return <>
        <UpsertLimingTemplate
            backUrl="/liming/approvals"
            footer={<>
                <div className="btn bg-red-500" onClick={() => setShowDecline(true)}>
                    {context.word('decline')}
                </div>
                <div className="btn bg-primary" onClick={() => setShowConfirm(true)}>
                    {context.word('approve')}
                </div>
            </>}
        />

        <Dialog
            title="Warning"
            body={
                <div>
                    <div className='p-4'>{context.word('approve_template')}</div>
                    <div className="w-full text-center p-2">
                        <div className="btn bg-primary" onClick={() => approve()}>Yes</div>
                        <div className="btn bg-red-500" onClick={() => setShowConfirm(false)}>No</div>
                    </div>
                </div>
            }
            show={showConfirm}
            setShow={setShowConfirm}
        />

        <Dialog
            setShow={setShowDecline}
            body={<DeclineDialog decline={decline} discard={() => setShowDecline(false)} />}
            show={showDecline}
            title={context.word('decline_message')}
        />
    </>
}

const DeclineDialog: React.FC<{
    discard: () => void
    decline: (message: string) => void
}> = (props) => {
    const context = useContext(AppContext)
    const [reason, setReason] = useState('')

    return (
        <div className="m-2">
            <div>{context.word('message')}</div>
            <textarea className="input w-full" {...bind(reason, setReason)}></textarea>
            <div className="flex gap-2 mt-4">
                <div className="btn bg-red-500" onClick={() => props.discard()}>
                    {context.word('discard')}
                </div>
                <div className="btn bg-primary" onClick={() => props.decline(reason)}>
                    {context.word('send')}
                </div>
            </div>
        </div>
    )
}

export default LimingTemplateApproval
